import { useEffect } from 'react';

import useFluxibleAction from 'js/lib/fluxibleHooks/useFluxibleAction';
import useFluxibleStore from 'js/lib/fluxibleHooks/useFluxibleStore';
import { useParams } from 'js/lib/useRouter';
import user from 'js/lib/user';

import { getCurrentSession } from 'bundles/course-sessions/actions/SessionActions';
import { loadUserGroupsForCourse } from 'bundles/group-enroll/actions/GroupSettingActions';
import { loadCertificateData } from 'bundles/in-course-stores/actions/CertificateActions';
import { loadCourseViewGrade } from 'bundles/in-course-stores/actions/CourseViewGradeActions';
import { loadHonorsUserPreferences } from 'bundles/in-course-stores/actions/HonorsUserPreferencesActions';
import { getProgress } from 'bundles/in-course-stores/actions/ProgressActions';
import CourseStore from 'bundles/in-course-stores/stores/CourseStore';

export const useLoadCourseStores = () => {
  const executeAction = useFluxibleAction();
  const { courseId } = useFluxibleStore(CourseStore, (store) => ({ courseId: store.getCourseId() }));
  const courseSlug = useParams().courseSlug;

  useEffect(() => {
    if (courseId && courseSlug) {
      const userId = user.get().id.toString();
      const authenticated = user.isAuthenticatedUser();

      executeAction(getCurrentSession, { courseSlug });
      executeAction(loadCourseViewGrade, { courseId });

      executeAction(loadUserGroupsForCourse, { courseId, userId });
      executeAction(loadHonorsUserPreferences, { authenticated });
      executeAction(loadCertificateData, { courseId, userId });

      executeAction(getProgress, { courseId, refreshProgress: false });
    }
  }, [courseId, courseSlug, executeAction]);
};
